module.exports = __webpack_public_path__ + "static/media/weekend_cropped.9274502d.png";